import { Typography } from "@mui/material";
import React from "react";

export interface FormContentProps {
  content: string;
  fontSize?: string;
  marginBottom?: number;
}

const FormContent = ({ content, fontSize, marginBottom }: FormContentProps) => {
  return (
    <Typography
      sx={{
        fontWeight: "400",
        fontSize: fontSize || "13px",
        marginBottom: marginBottom || 2,
      }}
    >
      {content}
    </Typography>
  );
};

export default React.memo(FormContent);
